// Safe wrapper around umami.track — no-op if umami isn't loaded
// (HEAD_HTML in /config.json is empty, dev mode, or script blocked).
export function trackEvent(name, data) {
  try {
    if (typeof window === 'undefined') return;
    window.umami?.track?.(name, data);
  } catch {
    // intentionally swallow — analytics must never break UX
  }
}
